<template>
  <ContinueQuote productType="plant-and-equipment" />
</template>

<script>
import ContinueQuote from "../../components/PSContinueQuote.vue";

export default {
  components: {
    ContinueQuote
  },
  async mounted() {
    console.log("c13");

  }
};
</script>
